import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {NgRedux, select} from '@angular-redux/store';
import {IAppState} from '../store/IAppState';
import {benchmarkChangedTo} from '../store/actions';
import {Observable, Subscription} from 'rxjs';
import {AnalyticsService, AnalyticsServiceToken} from '../analytics/analytics.service';
import {MetricType} from '../shared/metric-types';
import {DropdownOption, Legend} from '../shared/models';
import {BenchmarkType} from '../shared/benchmark-types';

@Component({
  selector: 'app-chart-legend',
  templateUrl: './chart-legend.component.html',
  styleUrls: ['./chart-legend.component.scss'],
})
export class ChartLegendComponent implements OnInit, OnDestroy {
  @Input() metricType: MetricType = MetricType.WorkRVUs;
  @Input() legends: Legend[];
  @Input() benchmarksToExclude: string[] | undefined;
  @Input() activeVarianceToggle: boolean;
  @Input() hasBenchmarks = true;
  @Input() defaultBenchmarkType: BenchmarkType | undefined;
  @Input() isSpecialtyPerformance = false;
  @Input() warningText: string;
  @Input() fromPdf = false;

  benchMarkType: BenchmarkType;

  @select(['benchmark'])
  private readonly benchmarkType$: Observable<BenchmarkType>;

  // noinspection JSUnusedLocalSymbols (this actually is used in the html)
  benchmarkTypes: DropdownOption[] = [
    {value: BenchmarkType.Mean, name: 'Mean'},
    {value: BenchmarkType.Percentile25th, name: '25th Percentile'},
    {value: BenchmarkType.Percentile50th, name: '50th Percentile'},
    {value: BenchmarkType.Percentile65th, name: '65th Percentile'},
    {value: BenchmarkType.Percentile75th, name: '75th Percentile'},
    {value: BenchmarkType.Percentile90th, name: '90th Percentile'},
  ];
  chartLegendDataSubscription: Subscription;

  constructor(
    @Inject(AnalyticsServiceToken) private analyticsService: AnalyticsService,
    private ngRedux: NgRedux<IAppState>,
  ) {
  }


  ngOnInit() {
    this.filterOutExcludedBenchmarks();
    this.chartLegendDataSubscription = this.benchmarkType$.subscribe((benchmarkTypeFromStore: BenchmarkType) => {
      const hasBenchmarkToMatchStore: boolean = !!this.benchmarkTypes.find(t => t.value === benchmarkTypeFromStore);
      this.benchMarkType = hasBenchmarkToMatchStore ? benchmarkTypeFromStore : this.getDefaultBenchmarkType();
    });
  }

  ngOnDestroy(): void {
    this.chartLegendDataSubscription?.unsubscribe();
  }

  updateBenchmarkType(value: BenchmarkType): void {
    this.ngRedux.dispatch(benchmarkChangedTo(value));
    this.analyticsService.handleGoogleAnalytics('wRVU by Provider Graph Benchmark', 'Benchmark Change', BenchmarkType[value]);
  }

  private filterOutExcludedBenchmarks() {
    if (this.benchmarksToExclude) {
      this.benchmarksToExclude.forEach(x => {
        this.benchmarkTypes = this.benchmarkTypes.filter(y => y.name !== x);
      });
    }
  }

  private getDefaultBenchmarkType() {
    return this.defaultBenchmarkType ? this.defaultBenchmarkType : BenchmarkType.Mean;
  }
}
